import React, { useRef, useState, useEffect } from "react";
import "@fortawesome/fontawesome-free/css/all.min.css";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import Container from "react-bootstrap/Container";
import LandingSection from "../components/LandingSection";
import ActionButton from "../utils/ActionButton";
import Footer from "../components/Footer";
import "../styles/Faq.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faIndustry,
  faChartLine,
  faCogs,
  faLightbulb,
} from "@fortawesome/free-solid-svg-icons";

import { Link } from "react-router-dom";
import { FaqSection } from "./FaqSection";
//import { FaqSection } from './FaqSection';
import "../styles/Aerospace.css";
import ModalFunction from "./Modal";
import TabTitle from "../components/TabTitle";
import { TransportationAndWarehousingFaqSection } from "./TransportationAndWarehousingFaqSection";
import { ConstructionFaq } from "./ConstructionFaq";

const logo = "/img/1.png";
const kpi = "/img/KPI-DASH 2.png";

export default function Construction() {
  const [expanded, setExpanded] = useState(false);
  const navbarRef = useRef(null);
  const [modalShow, setModalShow] = React.useState(false);

  // Close dropdown when clicking outside the navbar
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (navbarRef.current && !navbarRef.current.contains(event.target)) {
        setExpanded(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);
  return (
    <div>
      <LandingSection
        data={{
          imageName: "cons.webp",
          title: "Construction",
        }}
      />
      <div className="verticals_section">
        <div className="verticals-intro">
          <div className="verticals-intro-sec1">
            <h2>
              Building Utah’s Future: Construction Shaping
              Communities with Design and Innovation
            </h2>
          </div>
          <div className="verticals-intro-sec2">
            <p>
              Utah’s construction industry reflects a blend of
              tradition, modern innovation, and sustainable growth. From Salt
              Lake City’s skyline and historic landmarks to thriving residential
              communities and state-of-the-art commercial spaces, construction
              in Utah is driven by a commitment to quality and efficiency.
            </p>
          </div>
        </div>
      </div>
      <TabTitle />
      <ConstructionFaq />
      <Footer />
    </div>
  );
}
